const dark = ({ targetColor }) => targetColor;

export default dark;
